$(document).ready(function(){
    function parseDateTime(dateTimeStr) {
        // Expected format: YYYY-MM-DD HH:MM:SS
        const [datePart, timePart] = dateTimeStr.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hours, minutes, seconds] = timePart.split(':');
        
        return new Date(year, month - 1, day, hours, minutes, seconds);
    }
    
    function updateCountdown(selector, selectorWrapper) {
        const flashSaleSection = document.querySelector(selector);
        const flashSaleSectionWrapper = document.querySelector(selectorWrapper);
        if (!flashSaleSection) return;

        const startDate = parseDateTime(flashSaleSection.dataset.startDate).getTime();
        const endDate = parseDateTime(flashSaleSection.dataset.endDate).getTime();
        const now = new Date().getTime();

        // Hide section if sale hasn't started or has ended
        if (now < startDate || now > endDate) {
            flashSaleSectionWrapper.style.display = 'none';
            return;
        }

        const timeLeft = endDate - now;
        
        const totalHours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        flashSaleSection.querySelector('.hours').textContent = totalHours.toString().padStart(2, '0');
        flashSaleSection.querySelector('.minutes').textContent = minutes.toString().padStart(2, '0');
        flashSaleSection.querySelector('.seconds').textContent = seconds.toString().padStart(2, '0');
    }

    if($(".flash-sale__detail").length){
        updateCountdown('.flash-sale__detail', '.flash-sale__wrapper-detail');
        setInterval(() => updateCountdown('.flash-sale__detail', '.flash-sale__wrapper-detail'), 1000);
    }

    // if($(".cart-empty--header").length){
    //     $(".cart-empty--header").click(function(e) {
    //         e.preventDefault();
    //         location.href = "/cart"
    //     })
    // }

    // Initialize slick slider for elements with slider-custom class
    if ($('.slider-custom').length) {
        $.fn.equalHeights = function () {
            let maxHeight = 0;
        
            $(this).each(function () {
                maxHeight = Math.max($(this).height(), maxHeight);
                console.log(maxHeight)
            });
        
            $(this).each(function () {
                $(this).height(maxHeight);
            });
        };

        $('.slider-custom').each(function() {
            const $slider = $(this);
            const defaultOptions = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: true,
                speed: 500,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

            // Get custom options from data attributes if they exist
            const customOptions = $slider.data('slick') || {};
            
            // Merge default options with custom options
            const sliderOptions = {...defaultOptions, ...customOptions};
            
            // Initialize slick slider
            $slider.slick(sliderOptions);
            $(this).find(".card__information .card-information").equalHeights()
        });

        if($('.slider-custom__item.slider-spacer-fs').length){
            if (window.matchMedia('(min-width: 750px)').matches) {
                $('.slider-custom__item.slider-spacer-fs').remove();
            }
        }
    }

    function render_media_slider(){
        $('.product-media-custom__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.slider-button__media-custom.slider-button--prev'),
            nextArrow: $('.slider-button__media-custom.slider-button--next'),
            fade: true,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                        arrows: false,
                        dots: true,
                        prevArrow: null,
                        nextArrow: null
                    }
                }
            ]
        });
  
        $('.product-media-custom__thumbs').on('init', function(event, slick) {
            $('.product-media-custom__thumbs .slick-slide.slick-current').addClass('is-active');
        }).slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: false,
            arrows: false,
            focusOnSelect: false,
            infinite: false
        });
  
        $('.product-media-custom__slider').on('afterChange', function(event, slick, currentSlide) {
            $('.product-media-custom__thumbs').slick('slickGoTo', currentSlide);
            var currrentNavSlideElem = '.product-media-custom__thumbs .slick-slide[data-slick-index="' + currentSlide + '"]';
            $('.product-media-custom__thumbs .slick-slide.is-active').removeClass('is-active');
            $(currrentNavSlideElem).addClass('is-active');
        });
       
        $('.product-media-custom__thumbs').on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');
       
            $('.product-media-custom__slider').slick('slickGoTo', goToSingleSlide);
        });
    }

    if($(".product-media-custom").length){
        render_media_slider()
    }

    if($(".quick-add__submit").length){
        console.log("ada quick add")
        $('.quick-add__submit').on('click', function() {
            const checkPopup = setInterval(function() {
                if ($('quick-add-modal .product .grid__item.product__media-wrapper .product-media-custom__slider').length) {
                    clearInterval(checkPopup); // Stop interval agar tidak cek terus
                    render_media_slider()
                    // Jalankan fungsi kamu di sini
                }
            }, 500); // Cek setiap 100ms
        });

    }

    if($(".accordion-custom").length){
        $('.accordion-custom .tab__label').on('click', function() {
            $(this).toggleClass('tab-active');
            var content = $(this).next('.tab__content');
            
            if (content.css('maxHeight') && content.css('maxHeight') !== '1px') {
                content.css('maxHeight', '1px');
            } else {
                content.css('maxHeight', content[0].scrollHeight + 'px');
            }
        });
    }

    if($(".main-cart__template").length){
        $(".cart__items-pricing").append($("#main-cart-footer"))

        $('#select-all').change(function() {
            $('.select-item').prop('checked', this.checked);
        });
        $('.select-item').change(function() {
            if ($('.select-item:checked').length === $('.select-item').length) {
                $('#select-all').prop('checked', true);
            } else {
                $('#select-all').prop('checked', false);
            }
        });

        $('.delet-all__button').click(function() {
            $.ajax({
                url: '/cart/clear.js',
                type: 'POST',
                success: function() {
                    location.reload();
                },
                error: function() {
                    // jika error
                }
            });
        });
    }

    if($("[products-collection]").length){
        $(".submenu-category [target-collection]").click(function(e){
            e.preventDefault()
            var targetCollection = $(this).attr('target-collection');
            $(".products-collection").hide(300);
            $('.submenu-products').find(`.products-collection[products-collection="${targetCollection}"]`).show(500);

            $(".view-all__url").attr("href", `/collections/${targetCollection}`)
        })

        $("[data-drop]").click(function(e){
            e.preventDefault()
            $(this).toggleClass('active')
            $(this).parent().find(".menu-mobile__dropdown").toggle(300)
        })
    }

    if($(".tracking-form").length){
        var days = ['', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var month = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        function dateFormatRajaongkir(date){
            var pecah = date.split("-");
            var tahun = pecah[0];
            var bulan_ = pecah[1].startsWith("0") ? pecah[1].slice(1) : pecah[1];
            var bulan = month[bulan_];
            var tanggal = pecah[2];

            return `${tanggal} ${bulan} ${tahun}`;
        }
        
        $(".tracking-order__menu").click(function(){
            $(".tracking-order__menu").toggleClass("active")
            $(".tracking-form").toggle(500)
        })

        $("#track-by-order, #track-by-resi").on("submit", function(e){
            e.preventDefault();
            let order_number = $("[name=order_number]").val();
            let email = $("[name=email]").val();
            let resi = $("[name=tracking_number]").val();
            let button = $(this).find("button");

            $.ajax({
                type: "POST",
                url: "https://notify-general.shopify-plugin.devbdd.com/rajaongkir/trackingOrderTwo",
                data: {
                    url_shopify: Shopify.shop,
                    order_number: order_number,
                    email: email,
                    awb: resi,
                    form: $(this).attr("id")
                },
                // dataType: "json",
                beforeSend: function() {
                    button.html('Mohon Tunggu...');
                    button.prop('disabled', true);
                },
                success: function(response) {
                    var result = JSON.parse(response);
                    let status_ = result.status

                    if (status_ == 200) {
                        let status = result.data.rajaongkir.status;
                        if(status.code == 200){
                            let summary = result.data.rajaongkir.result.summary;
                            let details = result.data.rajaongkir.result.details;
        
                            let details_html = `
                                <div class="table-responsive tabel-details"><table class="table table-bordered table-hover table-striped"><tbody><tr><th>Status</th><td>${summary.status}</td></tr><tr><th>Nomor resi</th><td>${details.waybill_number}</td></tr><tr><th>Jenis layanan</th><td>${summary.service_code}</td></tr><tr><th>Tanggal pengiriman</th><td>${dateFormatRajaongkir(details.waybill_date)}</td></tr><tr><th>Berat kiriman</th><td>${details.weight}</td></tr><tr><th>Nama pengirim</th><td>${details.shippper_name}</td></tr><tr><th>Kota asal pengirim</th><td>${details.shipper_city}</td></tr><tr><th>Nama penerima</th><td>${details.receiver_name}</td></tr><tr><th>Alamat penerima</th><td>${details.receiver_address1}, ${details.receiver_address2 != "" ? details.receiver_address2 + ', ' : ""}${details.receiver_address3 != "" ? details.receiver_address3 + ', ' : ""}${details.receiver_city}</td></tr></tbody></table></div>
                            `;
        
                            let manifest = result.data.rajaongkir.result.manifest;
                            let manifest_item = ``;
                            manifest.forEach(history => {
                                manifest_item += `
                                    <tr>
                                        <td>${dateFormatRajaongkir(history.manifest_date)}, ${history.manifest_time}</td>
                                        <td>${history.city_name}</td>
                                        <td>${history.manifest_description}</td>
                                    </tr>
                                `;
                            });
        
                            let manifest_html = `
                                <div class="table-responsive tabel-manifest"><table class="table table-bordered table-hover table-striped"><thead><tr><th>Tanggal</th><th>Kota</th><th>Keterangan</th></tr></thead><tbody>${manifest_item}</tbody></table></div>
                            `;
        
                            $('.awb-history').html(details_html + manifest_html)
                        }
                        else{
                            $('.awb-history').html(status.description)
                        }
                    } else {
                        $('.awb-history').html(result.message)
                    }
    
                    $('html, body').animate({
                        scrollTop: $(".awb-history").offset().top
                    }, 500);

                    button.html('Track Order');
                    button.prop('disabled', false);
                },
                error: function(xhr, status, error) {
                    console.error("Error:", xhr.responseText);
                    alert('Terjadi kesalahan. Silakan refresh halaman.');
                }
            });
        })
    }

    if($(".suggested-product__article").length){
        if (window.matchMedia('(max-width: 749px)').matches) {
            $(".suggested-product__article .simple-product__card").each(function(){
                $(this).append($(this).find(".quick-add__wrapper"))
            })
        }
    }

    if (window.location.href.includes('a/wishlist')) {
        const formatPrice = (price) => {
            return new Intl.NumberFormat('id-ID', {
                minimumFractionDigits: 0, // Menghilangkan desimal
                maximumFractionDigits: 0, // Menghilangkan desimal
            }).format(price);
        };
        
        $('.wishlistpage .row .titletext').addClass("h3")
        $('.wishlistpage').prepend(`
            <nav class="breadcrumb page-width" role="navigation" aria-label="breadcrumbs">
                <ol class="breadcrumb__list">
                    <li class="breadcrumb__item">
                        <a href="/" class="breadcrumb__link">Gendes</a>
                        <svg class="icon icon-caret" viewBox="0 0 10 6">
                            <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>
                        </svg>
                    </li>
                    <li class="breadcrumb__item">
                        <span class="breadcrumb__link" aria-current="page">Wishlist</span>
                    </li>
                </ol>
            </nav>    
        `)
    
        let check_wishlist_interval = setInterval(() => {
            if ($('.wishlistpage .row.products #bookmarks .container-fluid').length) {
                let total_product = $('.wishlistpage .row.products #bookmarks .container-fluid .row .col-md-4').length
                let total_product_html = total_product > 1 ? `Total ${total_product} Products` : `Total ${total_product} Product`;
                $('.wishlistpage .wishlistbodycontainer').prepend(`
                    <span class="wishlist-total__product">${total_product_html}</span>    
                `)

                $('.wishlistpage .row.products #bookmarks .container-fluid .row .col-md-4').each(function (i, v) {
                    $(v).find(".product_title a").addClass("card-link-title")
                    $(v).find(".product .buttons .btn.addbutton").html(`
                        <span class="quick-add__submit-text">
                            Add to cart
                            <svg width="19" height="17" class="icon icon-cart" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.0999 6.34191C14.0999 8.33013 12.4881 9.94191 10.4999 9.94191C8.51168 9.94191 6.8999 8.33013 6.8999 6.34191M3.22717 18.9419H17.7726C19.0579 18.9419 20.0999 17.9193 20.0999 16.6579L18.609 3.34188C18.609 2.08045 17.567 1.05786 16.2817 1.05786H4.42717C3.14186 1.05786 2.0999 2.08045 2.0999 3.34188L0.899902 16.6579C0.899902 17.9193 1.94186 18.9419 3.22717 18.9419Z" stroke-width="1.5" stroke="#191919" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </span>
                    `).addClass('button button--full-width button--plain');
                    $(v).find(".product .buttons .btn.removebutton").html(`
                        <span class="fa fa-heart"></span>
                    `)

                    let product_handle = $(v).find('.product .image a').attr('href').split('?')[0]
                    $.ajax({
                        type: 'GET',
                        url: `${product_handle}.json`,
                        success: function (response) {
                            const product = response.product;
                            let variant = product.variants[0]

                            let price = variant.price * 1;
                            let compare_at_price = variant.compare_at_price * 1;
                            let content_price_html = `
                                <div class="price">
                                    <div class="price__container">
                                        <div class="price__regular">
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span class="price-item price-item--regular">
                                                Rp ${formatPrice(price)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            `;

                            if(compare_at_price != "" && compare_at_price > price) {
                                let discount = ((compare_at_price - price) / compare_at_price) * 100;
                                discount = Math.round(discount);
                                content_price_html = `
                                    <div class="price price--on-sale">
                                        <div class="price__container">
                                            <div class="price__regular">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span class="price-item price-item--regular">Rp ${formatPrice(price)}</span>
                                            </div>
                                            <div class="price__sale">
                                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                <span class="price-item price-item--sale price-item--last">Rp ${formatPrice(price)}</span>
                                                <div class="price__discount-wrapper">
                                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                    <span>
                                                        <s class="price-item price-item--regular">Rp ${formatPrice(compare_at_price)}</s>
                                                    </span>
                                                    <span class="price__discount">${discount}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                `;
                            }

                            $(`.product[data-productid='${product.id}'] .text .price`).parent().html(content_price_html).addClass('price-wishlist-item')
                        },
                        error: function (xhr, status, error) {
                            console.log(xhr.responseText)
                        }
                    })
                })
                clearInterval(check_wishlist_interval)
            }
        }, 0);
    }
});

